import React from 'react'

import useTrainingJourney from 'hooks/useTrainingJourney'

import IdentificationStep from './components/IdentificationStep'
import InvalidLinkScreen from './components/InvalidLinkScreen'
import VerifyCodeStep from './components/VerifyCodeStep'

const Journey = () => {
  const { activeStep, linkInvalid } = useTrainingJourney()

  if (linkInvalid) return <InvalidLinkScreen />

  return activeStep === 0 ? <IdentificationStep /> : <VerifyCodeStep />
}

export default Journey
